export const call = {
  status: {
    answered: 'Answered',
    busy: 'Busy',
    no_answer: 'No answer',
    failed: 'Failed'
  },

  type: {
    outgoing: 'Outgoing',
    incoming: 'Incoming'
  }
};
